import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-[80vh] flex items-center">
      <div className="max-w-[900px] mx-auto px-6 md:px-10 py-20">
        <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-novya-muted">Checkout cancelled</div>
        <h1 className="mt-6 font-display font-black text-4xl md:text-6xl tracking-tighter leading-[0.95] text-novya-ink">
          No charge made.
        </h1>
        <p className="mt-6 text-novya-muted max-w-xl">
          You backed out of Stripe before finishing checkout. Whenever you're ready, your seat is still open.
        </p>
        <div className="mt-10 flex gap-4">
          <Link to="/programs" data-testid="cancel-programs-btn" className="px-8 py-4 bg-novya-ink text-white font-medium hover:bg-novya-accent transition-colors">
            See programs
          </Link>
          <Link to="/dashboard" data-testid="cancel-dashboard-btn" className="px-8 py-4 border border-novya-ink text-novya-ink font-medium hover:bg-novya-ink hover:text-white transition-colors">
            Dashboard
          </Link>
        </div>
      </div>
    </div>
  );
}
